"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const formik_1 = require("formik");
const utilities_1 = require("@/utilities");
const style_1 = require("./style");
function SetRangeValueField({ onSetLowLimitValue, onSetHighLimitValue, lowLimitValue, highLimitValue, nameLowLimitValue, nameHighLimitValue, }) {
    return (react_1.default.createElement(style_1.Wrapper, null,
        react_1.default.createElement(formik_1.FastField, { name: nameLowLimitValue }, ({ field }) => {
            return (react_1.default.createElement(style_1.StyledInput, { ...field, variant: "standard", name: nameLowLimitValue, type: "number", onWheel: (event) => event.currentTarget.blur(), value: lowLimitValue, onChange: onSetLowLimitValue, id: nameLowLimitValue }));
        }),
        react_1.default.createElement(style_1.LessOrGreaterThan, null, (0, utilities_1.defineLessOrGreaterThan)(lowLimitValue, highLimitValue)),
        react_1.default.createElement(style_1.StyledInput, { variant: "standard", onWheel: (event) => event.currentTarget.blur(), name: nameHighLimitValue, type: "number", onChange: onSetHighLimitValue, id: nameLowLimitValue, value: highLimitValue })));
}
exports.default = react_1.default.memo(SetRangeValueField);
